//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// suggestion-action-config-settings imports
import { IContainer, IProps, IState } from "./SuggestionActionConfigSettings.d";
import { suggestionActionConfigSettingsFragments } from "./SuggestionActionConfigSettings.gql";
// import * as s from './SuggestionActionConfigSettings.styles';
import { SuggestionActionPersonalCalRenderer } from "../suggestion-action-personal-cal";
import { SuggestionActionColors } from "../suggestion-action-colors";
import { SuggestionActionSlack } from "../suggestion-action-slack";
import { SuggestionActionTravelTime } from "../suggestion-action-travel-time";
import { CardButton } from "@components/card";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { toggleExpanded, openTeam } from "@actions/settings.actions";
// util
import { EConfigType } from "@util/suggestion.util";
// material-ui
import { GroupAdd } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class SuggestionActionConfigSettingsCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onClick = (configType: ISchema.ConfigureSettingsType) => {
    switch (
      configType as any // FIXME: TEMP FIX FOR GQL2TS ISSUES
    ) {
      case EConfigType.SettingUpTeam:
        this.props.setSettingsDialogOpen(true);
        this.props.openTeam();
        break;
      case EConfigType.SettingUpWorkingHours:
        this.props.setSettingsDialogOpen(true);
        this.props.toggleExpanded("expandHours");
        break;
      case EConfigType.TravelTime:
        this.props.setSettingsDialogOpen(true);
        this.props.toggleExpanded("expandTravelTime");
        break;
      case EConfigType.MeetingColors:
      case EConfigType.PersonalCalendarSync:
      default:
      // fall through to just dismiss card
    }
    // finally, dismiss the card
    this.props.actionCallback();
  };

  public render() {
    const { payload, org } = this.props;

    switch (
      payload.configureSettingsType as any // FIXME: TEMP FIX FOR GQL2TS ISSUES
    ) {
      case EConfigType.PersonalCalendarSync:
        return (
          <SuggestionActionPersonalCalRenderer
            environment={this.props.relay.environment}
            actionCallback={() => this.props.actionCallback()}
          />
        );
      case EConfigType.MeetingColors:
        return (
          <SuggestionActionColors actionCallback={() => this.props.actionCallback()} org={org} />
        );
      case EConfigType.SlackStatusSync:
        return (
          <SuggestionActionSlack actionCallback={() => this.props.actionCallback()} org={org} />
        );
      case EConfigType.TravelTime:
        return (
          <SuggestionActionTravelTime
            actionCallback={() => this.props.actionCallback()}
            org={org}
          />
        );

      case EConfigType.SettingUpTeam:
        return (
          <CardButton
            flat
            textColor={this.props.buttonTextColor}
            onClick={() => this.onClick(payload.configureSettingsType)}
            label={"Set up your team"}
            icon={<GroupAdd />}
          />
        );
      default:
        return (
          <CardButton
            flat
            textColor={this.props.buttonTextColor}
            onClick={() => this.onClick(payload.configureSettingsType)}
            label={this.props.label}
          />
        );
    }
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SuggestionActionConfigSettingsRedux = connect(mapStateToProps, {
  setSettingsDialogOpen,
  toggleExpanded,
  openTeam,
})(SuggestionActionConfigSettingsCmpt);

//////////////////
// RELAY
//////////////////
export const SuggestionActionConfigSettings = createFragmentContainer<IContainer>(
  SuggestionActionConfigSettingsRedux,
  suggestionActionConfigSettingsFragments,
);
